import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export default function CustomSelect({ options, value, onChange, disabled, ref, name, label, error, helperText, onInputChange, inputValue }) {
    return (
        <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={options}
            sx={{ m: 1, width: "30ch" }}
            value={value}
            disabled={disabled}
            name={name}
            onChange={onChange}
            onInputChange={onInputChange}
            inputValue={inputValue}
            renderInput={
                (params) =>
                    <TextField {...params}
                        label={label}
                        error={error}
                        variant="outlined"
                        helperText={error && helperText}
                        inputRef={ref}
                    />
            }
        />
    );
}